<template>
  <div class="pag-wrap">
    <header class="header-box">
      <div class="top"></div>
      <div class="opera">
        <div class="back-area"
             @click="emits('changePage', 'package')"
        ></div>
        <div class="grow"></div>

        <right-user-icon
            show-back
            @changePage="name => emits('changePage', name)"
        />
      </div>
    </header>

    <div class="content-wrap">
      <aside class="side-bar">
        <div class="sidebar-head">账户中心</div>
        <el-menu
            :default-active="defaultActMenu"
            class="left-el-menu"
            unique-opened
        >
          <template
              v-for="(item,idx) in menuList"
              :key="idx"
          >
            <el-sub-menu
                v-if="item.children && Array.isArray(item.children)"
                :disabled="item.disabled"
                :index="item.key">
              <template #title>
                <el-icon>
                  <component
                      :is="item.icon"
                  />
                </el-icon>
                <span>{{ item.name }}</span>
              </template>
              <el-menu-item
                  v-for="(sub, sIdx) in item.children"
                  :key="sub.key"
                  :index="sub.key"
                  :disabled="sub.disabled"
                  @click="toggleComponent"
              >{{ sub.name }}
              </el-menu-item>
            </el-sub-menu>

            <el-menu-item
                v-else
                :index="item.key"
                :disabled="item.disabled"
                @click="toggleComponent"
            >
              <el-icon>
                <component
                    :is="item.icon"
                />
              </el-icon>
              {{ item.name }}
            </el-menu-item>
          </template>


        </el-menu>
      </aside>

      <main class="main-box">
        <component
            :is="pageView"
        />
      </main>
    </div>

    <div class="footer-wrap">

    </div>
  </div>
</template>

<script setup>
import addTaxUser from './addTaxUser.vue'
import toConfirmTaxUser from './toConfirmTaxUser.vue'
import alreadyTaxUser from './alreadyTaxUser.vue'
import enterpriseBase from './enterpriseBase.vue'
import toGrantEnter from './toGrantEnter.vue'
import personBase from './personBase.vue'
import RightUserIcon from "../cmp/rightUserIcon.vue";
import {ElMessage} from "element-plus";
import {useTaxUserStore} from "./addTaxPina.js";
import {onBeforeUnmount} from "vue";
import {$emit} from "vue-happy-bus";

const store = useTaxUserStore()
const {userAnswer} = storeToRefs(store);

const personMenus = [
  {
    name: '个人信息管理',
    icon: 'OfficeBuilding',
    key: 'personManage',
    children: [
      {
        name: '个人基本信息',
        key: 'personBase',
      },
      {
        name: '个人密码修改',
        key: 'personPwdModify',
        disabled: true,
      },
      {
        name: '手机号码修改',
        key: 'mobileModify',
        disabled: true,
      },
      {
        name: '个人信息维护',
        key: 'personInfoUphold',
        disabled: true,
      },
      {
        name: '服务协议',
        key: 'serviceAgree',
        disabled: true,
      },
      {
        name: '用户注销',
        key: 'userLogOff',
        disabled: true,
      },
    ]
  },
  {
    name: '企业授权管理',
    icon: 'OfficeBuilding',
    key: 'enterpriseGrant',
    children: [
      {
        name: '待确认授权',
        key: 'toGrantEnter',
      },
      {
        name: '已授权企业',
        key: 'alreadyGrantEnter',
        disabled: true,
      },
      {
        name: '历史管理信息',
        key: 'historyManageMsg',
        disabled: true,
      },
    ]
  },
  {
    name: '个人实名等级',
    icon: 'Document',
    key: 'personRealLevel',
    disabled: true,
  },
  {
    name: '个人证件管理',
    icon: 'Sunset',
    key: 'personCertification',
    disabled: true,
  },
  {
    name: '日志管理',
    icon: 'Memo',
    key: 'logManage',
    disabled: true,
  },
]

const enterpriseMenus = [
  {
    name: '企业信息管理',
    icon: 'OfficeBuilding',
    key: 'enterpriseInfo',
    children: [
      {
        name: '企业基本信息',
        key: 'enterpriseBase',
      },
    ]
  },
  {
    name: '人员权限管理',
    icon: 'MapLocation',
    key: 'user',
    children: [
      {
        name: '添加办税人员',
        key: 'addTaxUser',
      },
      {
        name: '待确认办税人员',
        key: 'toConfirmTaxUser',
      },
      {
        name: '现有办税人员',
        key: 'alreadyTaxUser',
      },
      {
        name: '历史管理消息',
        key: 'historyManageMsg',
        disabled: true,
      },
    ]
  },
  {
    name: '个人信息管理',
    icon: 'ChatRound',
    key: 'personInfo',
    disabled: true,
    children: [
      {
        name: '我的信息',
        key: 'myTodo',
      }
    ]
  },
  {
    name: '我的代理机构',
    icon: 'Monitor',
    key: 'myAgency',
    disabled: true,
  },
  {
    name: '身份切换',
    icon: 'Refresh',
    key: 'identChange',
    disabled: true,
    children: [
      {
        name: '我的信息',
        key: 'myTodo',
      }
    ]
  },
  {
    name: '日志管理',
    icon: 'Memo',
    key: 'logManage',
    disabled: true,
  },
]

const defaultActMenu = ref('')
const menuList = ref([])
const pageView = shallowRef(null);

const currentQa = inject('provideCurrentQa');

onMounted(() => {
  const loginType = sessionStorage.getItem('digTaxLoginType_' + currentQa.value.queId)
  if (loginType == null) {
    ElMessage.warning('登录失效')
    emits('changePage', 'stateTaxHome')
    return
  }

  if (loginType == 1) { // 当前为企业登录
    menuList.value = enterpriseMenus// personMenus
    defaultActMenu.value = 'addTaxUser'
    toggleComponent({index: 'addTaxUser'})
  } else if (loginType == 2) { // 自然人登录
    menuList.value = personMenus// personMenus
    defaultActMenu.value = 'toGrantEnter'
    toggleComponent({index: 'toGrantEnter'})
  }

  const ori = currentQa.value.solution && JSON.parse(currentQa.value.solution) || {
    userAnswer: [],
  };
  userAnswer.value = ori.userAnswer
})

onBeforeUnmount(() => {
  $emit("exeSaveQa");
})

function toggleComponent(ev) {
  switch (ev.index) {
    case 'addTaxUser':
      pageView.value = addTaxUser
      break
    case 'toConfirmTaxUser':
      pageView.value = toConfirmTaxUser
      break
    case 'alreadyTaxUser':
      pageView.value = alreadyTaxUser
      break
    case 'enterpriseBase':
      pageView.value = enterpriseBase
      break
    case 'toGrantEnter':
      pageView.value = toGrantEnter
      break
    case 'personBase':
      pageView.value = personBase
      break
    default:
      pageView.value = null
      break
  }
}

const emits = defineEmits(['changePage']);

const getGrandchildValue = inject("getGrandchildValue");
getGrandchildValue.value.getData = () => {
  return {
    solution: JSON.stringify({
      userAnswer: userAnswer.value || [],
    }),
  };
};

getGrandchildValue.value.getResetData = () => {
  userAnswer.value = []
  return {
    solution: "",
  };
};
</script>


<style scoped lang="scss">
.pag-wrap {
  display: flex;
  flex-direction: column;
  height: 100vh;

  .header-box {
    position: relative;

    .top {
      height: 56px;
      background-image: url(https://static.rhkj.com/renhe_fe/other/316.png);
      background-size: cover;
    }

    .opera {
      position: absolute;
      left: 0;
      bottom: 0;
      right: 0;
      top: 0;
      display: flex;
      align-items: center;
      box-sizing: border-box;
      padding-top: 3px;

      .back-area {
        height: 100%;
        width: 380px;
        cursor: pointer;
      }

      .grow {
        flex-grow: 1;
      }
    }
  }

  .content-wrap {
    height: 0;
    background-color: #f2f2f4;
    flex-grow: 1;
    box-sizing: border-box;
    padding: 20px;
    display: flex;

    .side-bar {
      flex-shrink: 0;
      width: 300px;
      margin-left: 20px;
      background-color: #FFFFFF;
      height: 100%;

      .sidebar-head {
        background: #3d77d8;
        font-size: 18px;
        font-weight: 700;
        color: #fff;
        height: 50px;
        line-height: 50px;
        text-align: center;
        border-radius: 2px 2px 0 0;
      }

      :deep(.left-el-menu) {
        .el-sub-menu.is-opened {
          .el-sub-menu__title {
            background-color: rgb(66, 133, 244);
            color: #FFFFFF;
          }
        }

        .el-menu-item.is-disabled {
          opacity: 0.75;
        }
        .el-sub-menu.is-disabled .el-sub-menu__title {
          opacity: 0.75;
        }
      }
    }

    .main-box {
      width: 0;
      flex-grow: 1;
      min-width: 900px;
      margin-left: 20px;
    }
  }

  .footer-wrap {
    height: 50px;
  }
}
</style>
